export const serializePath = (path: string[]): string => path.join(".");
